import { Link } from "react-router-dom";
import { getBreadcrumbTrail } from "@/data/seo";

// Pages that render the breadcrumb themselves, at the top of the page.
const RENDERED_BY_PAGE = new Set(["/bokforing-umea", "/bokforing-stockholm"]);

// Visible breadcrumb trail. It uses the same trail as the BreadcrumbList markup in the page head.
// "layout" (default) is the strip above the footer; "page" is the strip at the top of a page.
export const Breadcrumbs = ({ pathname, placement = "layout" }: { pathname: string; placement?: "layout" | "page" }) => {
  const trail = getBreadcrumbTrail(pathname);
  if (!trail) return null;
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (placement === "layout" && RENDERED_BY_PAGE.has(normalized)) return null;

  const navClass = placement === "page" ? "border-b border-border bg-background" : "border-t border-border bg-background";
  const olClass =
    placement === "page"
      ? "mx-auto flex max-w-[1200px] flex-wrap items-center gap-2 px-6 py-4 font-body text-xs text-foreground-muted lg:px-8"
      : "mx-auto flex max-w-7xl flex-wrap items-center gap-x-2 gap-y-1 px-6 py-4 text-sm text-foreground-muted";

  return (
    <nav aria-label="Brödsmulor" className={navClass}>
      <ol className={olClass}>
        {trail.map((item, index) => {
          const isLast = index === trail.length - 1;
          return (
            <li key={item.path} className="flex items-center gap-2">
              {index > 0 && <span aria-hidden="true">/</span>}
              {isLast ? (
                <span aria-current="page" className="text-foreground">
                  {item.name}
                </span>
              ) : (
                <Link to={item.path} className="hover:text-foreground hover:underline">
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
